import { createPortal } from "react-dom";
import styles from "./ModalDrawer.module.scss";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import useQueryURL from "../../../hooks/useQueryURL";
const CloseIcon = () => {
  return (
    <svg
      width="16"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.40298 24.4395L0 23.068L11.097 12.2197L0 1.37153L1.40298 0L12.5 10.8482L23.597 0L25 1.37153L13.903 12.2197L25 23.068L23.597 24.4395L12.5 13.5913L1.40298 24.4395Z"
        fill="black"
      />
    </svg>
  );
};

export interface ModalDrawerProps {
  children?: React.ReactNode;

  isOpen?: boolean;
  handleClose?: () => void;
  title?: string;
  urlParamName?: string;
  noClose?: boolean;
  onClose?: () => void;
  titleRender?: React.ReactNode;
  zIndex?: number;
}

/**
 * modal drawer
 * @returns
 */
export default function ModalDrawer({
  children,
  isOpen = true,
  handleClose,
  title,
  urlParamName,
  noClose,
  onClose: onCloseCallback,
  titleRender,
  zIndex,
  
}: ModalDrawerProps) {

  const [isParamsOpen, setParamsOpen] = useState(false);
  const {removeQueryValue, currentLocation, getQueryValue} = useQueryURL();
  const onClose = () => {
    if (urlParamName) {
      removeQueryValue([urlParamName]);
    }
    onCloseCallback && onCloseCallback();
  };

  useEffect(() => {
    if (!urlParamName) return;
    const openModalParam = getQueryValue(urlParamName);
    if (openModalParam === "true") {
      setParamsOpen(true);
    } else {
      setParamsOpen(false);
    }
  }, [currentLocation]); // eslint-disable-line react-hooks/exhaustive-deps
  const content = (
    <AnimatePresence mode="wait">
      {isParamsOpen && (
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ duration: 0.3, type: "easeInOut" }}
          className={styles["modal-drawer-container"]}
          style={{ zIndex: zIndex }}
        >
          <div
            className={[
              styles["modal-drawer-container__header-drawer"],
              styles["header-drawer"],
            ].join(" ")}
          >
            <div className={styles["header-drawer__title"]}>{title} {titleRender}</div>
            {!noClose && (
              <div
                className={styles["header-drawer__close"]}
                onClick={() => {
                  onClose();
                  handleClose && handleClose();
                }}
              >
                <CloseIcon />
              </div>
            )}
          </div>
          <div  className={styles["body"]}>
          {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  if (urlParamName) {
    return <>{createPortal(content, document.body)}</>;
  }

  return <>{isOpen && createPortal(content, document.body)}</>;
}
